import React, { useState } from 'react';

interface Props {
  texte: string;
  /** Nombre approximatif de caractères visibles avant repli. Défaut 220. */
  seuil?: number;
  /** Classes pour le bloc de texte (tailwind ok). */
  className?: string;
  /** Classes du bouton toggle. */
  boutonClassName?: string;
}

/**
 * Affiche un texte avec un bouton « Voir plus / Voir moins » quand il
 * dépasse `seuil` caractères. Coupe sur un espace pour éviter de
 * découper un mot en deux. Le bouton stoppe la propagation du clic pour
 * ne pas déclencher l'ouverture d'un card parent.
 */
export const ContenuExtensible: React.FC<Props> = ({
  texte, seuil = 220,
  className = 'text-xs text-gray-400 mt-1.5 whitespace-pre-line text-justify',
  boutonClassName = 'inline text-xs font-semibold text-amber-400 hover:text-amber-300',
}) => {
  const [ouvert, setOuvert] = useState(false);
  const long = texte.length > seuil;
  const affiche = !long || ouvert
    ? texte
    : texte.slice(0, seuil).replace(/\s+\S*$/, '') + '…';

  return (
    <div className={className}>
      {affiche}
      {long && (
        <>
          {' '}
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); e.preventDefault(); setOuvert(v => !v); }}
            className={boutonClassName}
          >
            {ouvert ? 'Voir moins' : 'Voir plus'}
          </button>
        </>
      )}
    </div>
  );
};
